"use client";

import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyMeShowStudentLabel: BaseKeyFunction = () => [
  "me",
  "show-student-label",
];
